import React, { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface DeleteConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
}

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  open,
  onConfirm,
  onCancel,
  title = 'Confirm Delete',
  message = 'Are you sure you want to delete this geofence? This action cannot be undone.',
}) => {
  console.log('DeleteConfirmationModal rendered');
  

  return (
    <Dialog open={open} onClose={onCancel} PaperProps={{ style: { borderRadius: 12 } }}>
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="overline">{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ pb: 4 }}>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default DeleteConfirmationModal;